import React, { useState } from 'react';
import {
  Button,
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerHeader,
  DrawerOverlay,
  FormControl,
  FormLabel,
  NumberInput,
  NumberInputField,
  Stack,
  Text,
  useDisclosure,
} from '@chakra-ui/react';
import { useSelector } from 'react-redux';

import { AccountMenuButton } from '../../account/AccountMenuButton';
import { selectUser } from '../../user/userSlice';
import { getEvseApReadinessSettings, saveEvseApReadinessSettings } from './evse-ap-readiness-settings';

/* istanbul ignore next -- @preserve */
export function EvseApReadinessSettings() {
  const user = useSelector(selectUser);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [settings, setSettings] = useState(getEvseApReadinessSettings);

  function handleOpen() {
    setSettings(getEvseApReadinessSettings());
    onOpen();
  }

  function handleSave() {
    saveEvseApReadinessSettings(settings);
    onClose();
  }

  return (
    <>
      {(user.role === 'SUPER_ADMIN' || user.role === 'STAFF') && (
        <AccountMenuButton data-testid="evse-ap-readiness-settings-button" onClick={handleOpen}>
          <Text fontSize={16} fontWeight="normal">
            EVSE AP Readiness
          </Text>
        </AccountMenuButton>
      )}

      <Drawer placement="bottom" onClose={onClose} isOpen={isOpen}>
        <DrawerOverlay />
        <DrawerContent maxH="calc(100dvh - env(safe-area-inset-top, 0px))" pb="env(safe-area-inset-bottom, 0px)">
          <DrawerCloseButton />
          <DrawerHeader borderBottomWidth="1px">EVSE AP Readiness Settings</DrawerHeader>
          <DrawerBody overflowY="auto" py={6}>
            <Stack spacing={5}>
              <FormControl>
                <FormLabel>Initial connect delay (seconds)</FormLabel>
                <NumberInput
                  min={0}
                  precision={0}
                  value={settings.initialConnectDelaySeconds}
                  onChange={(_, valueAsNumber) => {
                    if (Number.isInteger(valueAsNumber) && valueAsNumber >= 0) {
                      setSettings((current) => ({ ...current, initialConnectDelaySeconds: valueAsNumber }));
                    }
                  }}
                >
                  <NumberInputField data-testid="evse-ap-initial-connect-delay-input" inputMode="numeric" />
                </NumberInput>
              </FormControl>

              <FormControl>
                <FormLabel>Reconnect interval (seconds)</FormLabel>
                <NumberInput
                  min={1}
                  precision={0}
                  value={settings.reconnectIntervalSeconds}
                  onChange={(_, valueAsNumber) => {
                    if (Number.isInteger(valueAsNumber) && valueAsNumber >= 1) {
                      setSettings((current) => ({ ...current, reconnectIntervalSeconds: valueAsNumber }));
                    }
                  }}
                >
                  <NumberInputField data-testid="evse-ap-reconnect-interval-input" inputMode="numeric" />
                </NumberInput>
              </FormControl>

              <Button
                data-testid="save-evse-ap-readiness-settings-button"
                colorScheme="primaryBranding"
                onClick={handleSave}
              >
                Save
              </Button>
            </Stack>
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </>
  );
}
